/*
 * Copyright (C) 2020 Reciprocity, Inc - All Rights Reserved
 * Unauthorized use, copying, distribution, displaying, or public performance
 * of this file, via any medium, is strictly prohibited. All information
 * contained herein is proprietary and confidential and may not be shared
 * with any third party without the express written consent of Reciprocity, Inc.
 */

import { set } from 'lodash';

export const ToDoPageMixin = {
  mounted() {
    // I want to watch the world burn
    const $store = this.$store;
    const refreshListings = this.refreshListings.bind(this, this.$refs);
    document.body.dataset.csrf = this.csrfToken;
    window.GGRC = {
      ...window.GGRC,
      Notify: message => {
        $store.dispatch('alerts/show', message);
      },
    };

    // Capture page reloads
    this.$nextTick(() => {
      window.GGRC.zenModal.$on('reloadData', refreshListings);
    });
  },
  beforeDestroy() {
    delete window.GGRC;
  },
};

export const ToDoListingMixing = {
  watch: {
    listingData(newData) {
      set(
        window,
        `GGRC.zenModalContext[${this.listingId}]`,
        newData.map(row => ({ id: row.id }))
      );
      if (window.GGRC.zenModal && window.GGRC.zenModal.activeModal) {
        window.GGRC.zenModal.updateModal('context', window.GGRC.zenModal.activeModal.context, true);
      }
    },
  },
};
